// src/pages/FavoriteTechnicians.js
import React, { useState, useEffect } from "react";
import { ref, onValue, get, child } from "firebase/database";
import { useNavigate } from "react-router-dom";
import { auth, db } from "../utilities/firebaseConfig";

const FavoriteTechnicians = () => {
  const navigate = useNavigate();
  const [favorites, setFavorites] = useState([]);

  useEffect(() => {
    const user = auth.currentUser;
    if (!user) {
      navigate("/login");
      return;
    }
    const favRef = ref(db, `favorites/${user.uid}`);
    onValue(favRef, async (snapshot) => {
      const favData = snapshot.val();
      if (favData) {
        const techIds = Object.keys(favData);
        const techPromises = techIds.map((techId) =>
          get(child(ref(db), `technicians/${techId}`)).then((snap) => ({
            id: techId,
            ...snap.val(),
          }))
        );
        const techs = await Promise.all(techPromises);
        setFavorites(techs);
      } else {
        setFavorites([]);
      }
    });
  }, [navigate]);

  return (
    <div>
      <h2>Favorite Technicians</h2>
      {favorites.length > 0 ? (
        favorites.map((tech) => (
          <div key={tech.id} style={{ border: "1px solid #ccc", padding: "10px", margin: "10px" }}>
            <h4>{tech.name}</h4>
            <p><strong>Service:</strong> {tech.service}</p>
            <button onClick={() => navigate(`/select-technician/${tech.id}`)}>Select Technician</button>
          </div>
        ))
      ) : (
        <p>You have no favorite technicians yet.</p>
      )}
    </div>
  );
};

export default FavoriteTechnicians;
